import { AuthProvider } from "./context/AuthContext";
import CreateRoutes from "./routes";

function App() {
  return (
    <AuthProvider>
      <CreateRoutes />
    </AuthProvider>
  );
}

export default App;
